import { useQuery } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const QUERY = graphql(`
  query checkPrintRuleAssignment($menuPrintRuleId: ID!) {
    checkPrintRuleAssignment(menuPrintRuleId: $menuPrintRuleId) {
      id
    }
  }
`);

export function useCheckPrintRuleAssignment(menuPrintRuleId: string) {
  return useQuery(QUERY, {
    variables: {
      menuPrintRuleId: menuPrintRuleId,
    },
  });
}
